// @ts-nocheck
import React from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import styles from "./SearchData.module.scss";

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function DatePickerHeader({
  date,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}) {
  const years = Array.from(
    { length: 100 },
    (_, i) => new Date().getFullYear() - i
  );

  return (
    <div style={{ textAlign: "center", paddingBottom: "8px" }}>
      <div
        style={{
          marginBottom: "10px",
          display: "flex",
          gap: "10px",
          justifyContent: "center",
        }}
      >
        <select
          style={{
            fontSize: "16px",
            padding: "6px 10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
          }}
          value={MONTHS[date.getMonth()]}
          onChange={({ target: { value } }) =>
            changeMonth(MONTHS.indexOf(value))
          }
        >
          {MONTHS.map((month) => (
            <option key={month} value={month}>
              {month}
            </option>
          ))}
        </select>
        <select
          style={{
            fontSize: "16px",
            padding: "6px 10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
          }}
          value={date.getFullYear()}
          onChange={({ target: { value } }) => changeYear(Number(value))}
        >
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <button
          type="button"
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
          style={{
            fontSize: "18px",
            padding: "2px 8px",
            cursor: "pointer",
          }}
        >
          {"<"}
        </button>
        <span style={{ fontWeight: "bold", fontSize: "16px" }}>
          {MONTHS[date.getMonth()]} {date.getFullYear()}
        </span>
        <button
          type="button"
          onClick={increaseMonth}
          disabled={nextMonthButtonDisabled}
          style={{
            fontSize: "18px",
            padding: "2px 8px",
            cursor: "pointer",
          }}
        >
          {">"}
        </button>
      </div>
    </div>
  );
}

export default function SearchForm(p: any) {
  const {
    searchQuery,
    setSearchQuery,
    handleSearchFor,
    handleSearchChanges,
    allDates,
    enableAllDates,
    parishOptions,
    selectedParishes,
    handleSelectParishes,
    categoryOptions,
    selectedCategories,
    handleSelectCategories,
    deaneryOptions,
    selectedDeaneries,
    handleSelectDeaneries,
    retreatOptions,
    selectedRetreats,
    handleSelectRetreat,
    languagesOptions,
    selectedLanguages,
    handleSelectLanguages,
    coupleOptions,
    selectedCouples,
    handleSelectCouples,
    searchFor,
    location,
    selectedLocation,
    handleSelectLocation,
    ciytState,
    selectedStateCity,
    handleSelect1,
    zip,
    selectedZips,
    handleSelectZip,
    serviceDataList,
    rolesDataList,
    talksDataList,
    location1 = { state: null },
    searchRetreatsAndCouples,
    resetForm,
  } = p;

  return (
    <form className={styles.form} id="searchForm">
      <div className={styles.modeRow}>
        <span className={styles.modeLabel}>Search For</span>
        <div className={styles.segment} role="radiogroup" aria-label="Search For">
          <label
            className={`${styles.segmentOpt} ${
              searchQuery.searchFor === "retreat" ? styles.segmentOn : ""
            }`}
          >
            <input
              type="radio"
              id="retreadRad"
              className={styles.segmentInput}
              checked={searchQuery.searchFor === "retreat"}
              onChange={(e) => {
                handleSearchFor(e);
                handleSearchChanges(e);
              }}
              value="retreat"
              name="searchFor"
            />
            Retreats
          </label>
          <label
            className={`${styles.segmentOpt} ${
              searchQuery.searchFor === "couple" ? styles.segmentOn : ""
            }`}
          >
            <input
              type="radio"
              id="coupleRad"
              className={styles.segmentInput}
              checked={searchQuery.searchFor === "couple"}
              onChange={(e) => {
                handleSearchFor(e);
                handleSearchChanges(e);
              }}
              value="couple"
              name="searchFor"
            />
            Couples
          </label>
        </div>
      </div>

      <div className={styles.grid}>
        <div className={`${styles.field} ${styles.section}`}>
          <div className={styles.dateHead}>
            <label className={styles.label} htmlFor="dateFrom">
              Search By Date
            </label>
            <label className={styles.checkItem}>
              <input
                type="checkbox"
                className="form-check-input"
                name="allDates"
                onChange={(e) => enableAllDates(e)}
                value={allDates}
              />
              All Dates
              <i className="input-helper"></i>
            </label>
          </div>
          <div className={styles.dateRow}>
            <DatePicker
              required
              autoComplete="off"
              dateFormat="MM-dd-yyyy"
              onChange={(date) => {
                let d = { ...searchQuery };
                d["dateFrom"] = date;
                setSearchQuery(d);
              }}
              selected={searchQuery.dateFrom}
              placeholderText="mm-dd-yyyy"
              className="form-select setdate datepicker"
              name="dateFrom"
              id="dateFrom"
              disabled={allDates === true ? false : true}
              renderCustomHeader={DatePickerHeader}
            />
            <span className={styles.dateSep}>–</span>
            <DatePicker
              required
              autoComplete="off"
              dateFormat="MM-dd-yyyy"
              selected={searchQuery.dateTo}
              placeholderText="mm-dd-yyyy"
              onChange={(date) => {
                let d = { ...searchQuery };
                d["dateTo"] = date;
                setSearchQuery(d);
              }}
              className="form-select setdate datepicker"
              name="dateTo"
              id="dateTo"
              showDisabledMonthNavigation
              disabled={allDates === true ? false : true}
              renderCustomHeader={DatePickerHeader}
            />
          </div>
        </div>

        <div className={styles.field}>
          <label className={styles.label} htmlFor="parishCategory">
            Search By Category
          </label>
          <Select
            id="parishCategory"
            name="parishCategory"
            options={categoryOptions}
            value={selectedCategories}
            onChange={handleSelectCategories}
            labelledBy="Select"
            isSearchable={true}
            isMulti={true}
          />
        </div>

        <div className={styles.field}>
          <label className={styles.label} htmlFor="deanery">
            Search By Deanery
          </label>
          <Select
            id="deanery"
            name="deanery"
            options={deaneryOptions}
            value={selectedDeaneries}
            onChange={handleSelectDeaneries}
            labelledBy="Select"
            isSearchable={true}
            isMulti={true}
          />
        </div>

        <div className={styles.field}>
          <label className={styles.label} htmlFor="parish">
            Search By Parish
          </label>
          <Select
            id="parish"
            name="parish"
            options={parishOptions}
            value={selectedParishes}
            onChange={handleSelectParishes}
            labelledBy="Select"
            isSearchable={true}
            isMulti={true}
          />
        </div>

        <div className={styles.field}>
          <label className={styles.label} htmlFor="retreat">
            Search By Retreats
          </label>
          <Select
            id="retreat"
            name="retreat"
            options={retreatOptions}
            value={selectedRetreats}
            onChange={handleSelectRetreat}
            labelledBy="Select"
            isSearchable={true}
            isMulti={true}
          />
        </div>

        <div className={styles.field}>
          <label className={styles.label} htmlFor="language">
            Search By Language
          </label>
          <Select
            id="language"
            name="language"
            options={languagesOptions}
            value={selectedLanguages}
            onChange={handleSelectLanguages}
            labelledBy="Select"
            isSearchable={true}
            isMulti={true}
          />
        </div>

        <div className={styles.field}>
          <label className={styles.label} htmlFor="couple">
            Search By Couples
          </label>
          <Select
            id="couple"
            name="couple"
            options={coupleOptions}
            value={selectedCouples}
            onChange={handleSelectCouples}
            labelledBy="Select"
            isSearchable={true}
            isMulti={true}
          />
        </div>

        {searchFor === "retreat" ? (
          <div className={styles.field}>
            <label className={styles.label} htmlFor="location">
              Location
            </label>
            <Select
              name="location"
              options={location}
              value={selectedLocation}
              onChange={handleSelectLocation}
              labelledBy="Select"
              isSearchable={true}
              isMulti={true}
            />
          </div>
        ) : (
          <div className={styles.field}>
            <label className={styles.label} htmlFor="cityState">
              City / State
            </label>
            <Select
              name="cityState"
              options={ciytState}
              value={selectedStateCity}
              onChange={handleSelect1}
              labelledBy="Select"
              isSearchable={true}
              isMulti={true}
            />
          </div>
        )}

        {searchFor == "couple" ? (
          <div className={styles.field}>
            <label className={styles.label} htmlFor="primaryKey">
              Search By Couple Id
            </label>
            <input
              type="text"
              className="form-control"
              id="primaryKey"
              name="primaryKey"
              onChange={(e) => handleSearchChanges(e)}
              placeholder="Enter Couple Id"
              value={searchQuery.primaryKey == 0 ? "" : searchQuery.primaryKey}
            />
          </div>
        ) : null}

        <div className={styles.field}>
          <label className={styles.label} htmlFor="zip">
            Zip Code
          </label>
          <Select
            name="zip"
            options={zip}
            value={selectedZips}
            onChange={handleSelectZip}
            labelledBy="Select"
            isSearchable={true}
            isMulti={true}
          />
        </div>

        {searchFor == "retreat" ? (
          <div className={styles.section}>
            <span className={styles.label}>Search In Retreat</span>
            <div className={styles.checkGrid}>
              <label className={styles.checkItem}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="retreatants"
                  onChange={(e) => handleSearchChanges(e)}
                  value={"Team"}
                  checked={
                    searchQuery.retreatants.findIndex((s) => s == "Team") > -1
                      ? true
                      : false
                  }
                />
                Team
                <i className="input-helper"></i>
              </label>
              <label className={styles.checkItem}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="retreatants"
                  onChange={(e) => handleSearchChanges(e)}
                  value={"Retreatant"}
                  checked={
                    searchQuery.retreatants.findIndex((s) => s == "Retreatant") >
                    -1
                      ? true
                      : false
                  }
                />
                Retreatant
                <i className="input-helper"></i>
              </label>
            </div>
          </div>
        ) : (
          <div className={styles.field}>
            <label className={styles.label} htmlFor="retreatAttended">
              Retreats Attended
            </label>
            <label className={styles.checkItem}>
              <input
                type="checkbox"
                className="form-check-input"
                name="retreatAttended"
                onChange={(e) => handleSearchChanges(e)}
                value={searchQuery.retreatAttended}
                checked={searchQuery.retreatAttended}
              />
              No. Of Times Retreats Attended
              <i className="input-helper"></i>
            </label>
          </div>
        )}

        <div className={styles.section}>
          <span className={styles.label}>Service Title</span>
          <div className={styles.checkGrid}>
            {serviceDataList.length
              ? serviceDataList.map((item) => (
                  <label
                    className={styles.checkItem}
                    key={`servTitle-${item.id}`}
                  >
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="service"
                      onChange={(e) => handleSearchChanges(e, item.id)}
                      value={item.id}
                      checked={
                        searchQuery.serviceIds.findIndex((id) => id == item.id) >
                        -1
                          ? true
                          : false
                      }
                    />
                    {item.service}
                    <i className="input-helper"></i>
                  </label>
                ))
              : " "}
            <label className={styles.checkItem}>
              <input
                type="checkbox"
                className="form-check-input"
                name="neverService"
                onChange={(e) => {
                  handleSearchChanges(e);
                }}
                value={searchQuery.neverServedTeam}
                checked={searchQuery.neverServedTeam}
              />
              Never Served On Team
              <i className="input-helper"></i>
            </label>
          </div>
        </div>

        <div className={styles.section}>
          <span className={styles.label}>Service Role</span>
          <div className={styles.checkGrid}>
            {rolesDataList.length
              ? rolesDataList.map((item) => (
                  <label
                    className={styles.checkItem}
                    key={`servRol-${item.id}`}
                  >
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="serviceRole"
                      onChange={(e) => handleSearchChanges(e, item.id)}
                      value={item.id}
                      checked={
                        searchQuery.roleIds.findIndex((id) => id == item.id) > -1
                      }
                    />
                    {item.role}
                    <i className="input-helper"></i>
                  </label>
                ))
              : " "}
            <label className={styles.checkItem}>
              <input
                type="checkbox"
                className="form-check-input"
                name="neverServiceRole"
                onChange={(e) => {
                  handleSearchChanges(e);
                }}
                value={searchQuery.neverServiceRole}
                checked={searchQuery.neverServiceRole}
              />
              No Service Role
              <i className="input-helper"></i>
            </label>
          </div>
        </div>

        <div className={styles.section}>
          <span className={styles.label}>Talks</span>
          <div className={styles.checkGrid}>
            {talksDataList && talksDataList.length
              ? talksDataList.map((item, index) => (
                  <label
                    className={styles.checkItem}
                    key={`servTalk-${index}`}
                  >
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="talks"
                      onChange={(e) => handleSearchChanges(e, item.talkId)}
                      value={item && item.talkId}
                      checked={
                        searchQuery.talkIds.findIndex(
                          (id) => id == item.talkId
                        ) > -1 ||
                        (location1.state && location1.state.reportId === 3)
                          ? true
                          : false
                      }
                    />
                    {item.talk}
                    <i className="input-helper"></i>
                  </label>
                ))
              : " "}
            <label className={styles.checkItem}>
              <input
                type="checkbox"
                className="form-check-input"
                name="neverTalk"
                onChange={(e) => {
                  handleSearchChanges(e);
                }}
                value={searchQuery.neverTalk}
                checked={searchQuery.neverTalk}
              />
              Never Given Talk
              <i className="input-helper"></i>
            </label>
          </div>
        </div>

        {searchFor != "couple" ? (
          <div className={styles.section}>
            <div className={styles.checkGrid}>
              <label className={styles.checkItem}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="missingMails"
                  onChange={(e) => {
                    handleSearchChanges(e);
                  }}
                  value={searchQuery.missingMails}
                  checked={searchQuery.missingMails}
                />
                Missing Email Couples
                <i className="input-helper"></i>
              </label>
            </div>
          </div>
        ) : null}

        {searchFor == "couple" ? (
          <div className={styles.section}>
            <span className={styles.label}>Couples Status</span>
            <div className={styles.checkGrid}>
              <label className={styles.checkItem}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="coupleStatus"
                  onChange={(e) => handleSearchChanges(e)}
                  value={"ACTIVE"}
                  checked={
                    searchQuery.accountStatus.findIndex((s) => s == "ACTIVE") >
                    -1
                      ? true
                      : false
                  }
                />
                Active
                <i className="input-helper"></i>
              </label>
              <label className={styles.checkItem}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="coupleStatus"
                  onChange={(e) => handleSearchChanges(e)}
                  value={"DECEASED"}
                  checked={
                    searchQuery.accountStatus.findIndex((s) => s == "DECEASED") >
                    -1
                      ? true
                      : false
                  }
                />
                Deceased
                <i className="input-helper"></i>
              </label>
              <label className={styles.checkItem}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="coupleStatus"
                  onChange={(e) => handleSearchChanges(e)}
                  value={"DIVORCED"}
                  checked={
                    searchQuery.accountStatus.findIndex((s) => s == "DIVORCED") >
                    -1
                      ? true
                      : false
                  }
                />
                Divorced
                <i className="input-helper"></i>
              </label>
            </div>
          </div>
        ) : null}
      </div>

      <div className={styles.actions}>
        <button
          type="button"
          className={styles.primaryBtn}
          onClick={(e) => searchRetreatsAndCouples(e)}
        >
          Search
        </button>
        <button
          type="button"
          className={styles.ghostBtn}
          onClick={(e) => resetForm(e)}
        >
          Reset
        </button>
      </div>
    </form>
  );
}
